export default "__VITE_ASSET__D2uQy_vk__"